import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { SectionHeader } from "../../../Common/SharedComponents";
import { incomePaymentDetailsLabels } from "../../Resource/Contents";
import { CappedArrangementIncomeDetail } from "../../../../../../../Wrap/Models/Domains/Drawdown/CappedArrangementIncomeDetail";

interface IPensionDetailsProps {
    data: CappedArrangementIncomeDetail[];
    arrangementId?: number;
    arrangementValuationForGadReview?: number;
}

interface IPensionDetailsState {}

export class PensionDetails extends FormComponent<IPensionDetailsProps, IPensionDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, arrangementId, arrangementValuationForGadReview } = this.props;
        const incomeDetail = data.filter((ele) => ele?.ArrangementId == arrangementId)[0];

        return (
            <>
                {SectionHeader("Current income year")}
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.gadMaximum}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay({ Amount: incomeDetail?.GadMaximum, Currency: CurrencyCode.GBP })}
                    </span>
                </div>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.pensionYearEndDate}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {JsonDateParser.getFormatDate(incomeDetail?.ReferencePeriodEndDate, "dd/MM/yyyy")}
                    </span>
                </div>
                <hr />
                {SectionHeader("New details available for review")}
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.totalPostRetirementAccountValue}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                    {this.getMoneyDisplay({Amount: arrangementValuationForGadReview, Currency: CurrencyCode.GBP})}
                    </span>
                </div>
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.expectedGadMaximum}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {this.getMoneyDisplay({Amount: incomeDetail?.NextGadMaximum, Currency: CurrencyCode.GBP})}
                    </span>
                </div>
            </>
        );
    }

    private getMoneyDisplay(data: Money) {
        return MoneyDisplayHelper.FromatMoneyDisplay(data?.Amount || 0, data?.Currency || CurrencyCode.GBP);
    }
}
